<template>
    <b-col lg="3" md="6">
        <b-row class="max-height">
            <b-col :class="computedBackgroundBorder" class="solution-tile">
                <b-row>
                    <b-col :class="idx % 2 === 0 ? 'solution-main-light' : 'solution-main-dark'" class="solution-header">
                        <h3 :class="idx % 2 === 0 ? 'solution-main-light' : 'solution-main-dark'" class="solution-title">
                            <slot></slot>
                        </h3>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col align="center" class="solution-logo">
                        <b-img fluid :src="picUrl" class="solution-pic shadowed"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col align="center">
                        <a :href="getLink" target='_blank'>
                            <!-- v-on:click="openDemo"-->
                            <button :class="idx % 2 === 0 ? 'solution-main-light' : 'solution-main-dark'" class="btn btn-small solution-button" type="button">
                                demo
                            </button>
                        </a>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    import {pmisColorsMixin} from "../../../mixins/pmis-colors-mixin";
    // import {presentation} from "../../presentation/presentation";
    import presentation from "./../../data/presentation";

    export default {
        name: "PlaygroundSolution",
        props: ["name", "idx"],
        mixins: [pmisColorsMixin],
        computed: {
            picUrl() {
                return "./pic/logos/" + this.convertedName + "-logo.png";
            },
            getLink() {
                return presentation[this.name].demoSrc;
            }
        },
        methods: {
            openDemo() {
                this.$modal.show("single-element-modal-dialog", presentation[this.name]);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .solution-title {
        font-size: 1.4em;
        text-align: center;
        margin-top: 10px;
        color: white;
    }

    .solution-logo {
        margin: 4vh 2vw;
        height: 56px;
    }

    .solution-button {
        margin-bottom: 15px;
        color: white;
        font-size: 1.5em;
    }

    .solution-header {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }

    .solution-pic {
        max-height: 56px;
    }

</style>
